
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Budget & Expenses</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item" *ngIf="projectId &amp;&amp; projectName"><a [routerLink]="['/project']" [queryParams]="{id: projectId}">{{ projectName }}</a></li>
        <li class="breadcrumb-item active">Budget & Expenses</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row margin-bottom-10">
    <div class="col">
      <div class="btn-group btn-group-sm float-left">
        <button class="btn btn-sm" [ngClass]="amountType === 'usdAmount' ? 'btn-primary' : 'btn-outline-primary'" (click)="setAmountType('usdAmount')">USD</button>
        <button class="btn btn-sm" [ngClass]="amountType !== 'usdAmount' ? 'btn-primary' : 'btn-outline-primary'" (click)="setAmountType('localAmount')" *ngIf="projectCurrency &amp;&amp; projectCurrency !== 'USD'">{{ projectCurrency }}</button>
      </div>
      <div class="btn-group btn-group-sm float-right">
        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="chooseCARDAccount()">Change CARD Account</button>
        <button class="btn btn-sm btn-outline-primary" type="button" (click)="importExpenses()">Reload from CARD</button>
      </div>
    </div>
  </div>
  <div class="row margin-bottom-10" *ngIf="loading">
    <div class="col">
      <md-spinner-block></md-spinner-block>
    </div>
  </div>
  <div class="row margin-bottom-10" *ngIf="!loading">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="card-item margin-bottom-10 pb-5">
            <div class="row">
              <div class="col-12">
                <div class="row text-center">
                  <div class="col">
                    <h2>Summary</h2>
                  </div>
                </div>
                <div class="row text-center">
                  <div class="col-md-4">
                    <h6>Total Budget ({{ currency }})</h6>
                    <h4 class="no-mrg-vertical font-size-35">{{ summary.budget[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</h4>
                  </div>
                  <div class="col-md-4">
                    <h6>Total Expenses ({{ currency }})</h6>
                    <h4 class="no-mrg-vertical font-size-35">{{ summary.expenses[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</h4>
                  </div>
                  <div class="col-md-4">
                    <h6>Remaining Budget ({{ currency }})</h6>
                    <h4 [ngClass]="summary.remaining[amountType] &gt;= 0 ? 'text-success' : 'text-danger'">{{ summary.remaining[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-center" *ngFor="let bucket of summary.buckets">
              <div class="col-md-8 mt-5">
                <div class="row">
                  <div class="col">
                    <h4>{{ bucket.bucket }}</h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <table class="table table-sm table-responsive">
                      <thead>
                        <tr>
                          <th class="text-right">Month</th>
                          <th class="text-right">CO DART</th>
                          <th class="text-right">Budget</th>
                          <th class="text-right">Expense</th>
                          <th class="text-right">Remaining</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let month of bucket.months" [ngClass]="month.remaining[amountType] &gt;= 0 ? '' : 'table-danger'">
                          <th class="text-right">{{ month.month }}</th>
                          <th class="text-right">{{ month.changeOrder[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</th>
                          <th class="text-right">{{ month.budget[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</th>
                          <th class="text-right">{{ month.expenses[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</th>
                          <th class="text-right">{{ month.remaining[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="btn-group float-right"><a class="font-weight-light nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show financial details" *ngIf="!this.detailVisible[bucket.bucket]" (click)="showExpenseDetail(bucket.bucket)">Financial details<span class="icon oi oi-chevron-bottom margin-left-4"></span></a><a class="font-weight-light nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show financial details" *ngIf="this.detailVisible[bucket.bucket]" (click)="showExpenseDetail(bucket.bucket)">Financial details<span class="icon oi oi-chevron-top margin-left-4"></span></a></div>
                  </div>
                </div>
                <div class="row" *ngIf="this.detailVisible[bucket.bucket]">
                  <div class="col">
                    <div class="row">
                      <div class="col"></div>
                    </div>
                    <div class="row mt-4 bg-soft-blue">
                      <div class="col"><span class="mb-4 mt-3 d-inline-block font-weight-bold">Financial Detail: {{ bucket.bucket }}</span>
                        <div class="float-right mt-3"><a class="btn btn-sm btn-outline-primary" [downloadFile]="'/api/projects/export-project-financial-bucket-detail'" [params]="{projectId: projectId, queryStartDate: projectStartDate, bucket: bucket.bucket}"><span>Export Financial Details</span></a></div>
                        <filtered-list-controls class="mt-5" [list]="this.details[bucket.bucket]">
                          <fieldset></fieldset>
                        </filtered-list-controls>
                        <form [formGroup]="this.details[bucket.bucket].form">
                          <table class="mt-4 table table-sm table-responsive" formArrayName="items">
                            <thead>
                              <tr class="table-header-with-controls">
                                <th class="text-right">Month</th>
                                <th class="text-right">CO DART</th>
                                <th class="text-right">Expenses ({{ currency }})</th>
                                <th class="text-right">Employee</th>
                                <th class="text-right">Attribute</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let item of this.details[bucket.bucket].filtered" [formGroupName]="item.index">
                                <td class="text-right">{{ item.month }} ({{ item.period }})</td>
                                <td class="text-right">{{ item.changeOrder | currency:currency:'symbol-narrow':'1.2-2' }}</td>
                                <td class="text-right">{{ item[amountType] | currency:currency:'symbol':'1.2-2' }}</td>
                                <td class="text-right">{{ item.employeeName }}</td>
                                <td class="text-right">{{ item.attribute }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>